module.exports = __webpack_public_path__ + "static/ettin_and_pigs-ca71518a690095e424448cae81c9fb7b.png";